import React, { useState } from 'react'
import { PrimaryButton } from '@truphone/buttons'

const maxLength = 1024

function YesNoBlock(props) {
  const [answer, setAnswer] = useState(null)
  const [comment, setComment] = useState('')

  const submitFeedBack = (helpful, comment) => {
    if (props.submitAction) {
      props.submitAction(helpful, comment)
    }

    setAnswer(1)
  }

  const charactersRemaining = maxLength - comment.length
  return (
    <div>
      {!answer ? (
        <div className="py-8 flex items-center">
          <p className="text-base opacity-60 mr-2">{props.question}</p>

          {props.yes && (
            <button
              onClick={() => {
                setAnswer(1)
                submitFeedBack(true)
              }}
              className="hover:bg-grey-100 uppercase px-4 py-2 text-sm font-bold tracking-wider bg-transparent border-2 rounded-sm mx-1"
            >
              {props.yes}
            </button>
          )}
          {props.no && (
            <button
              onClick={() => setAnswer(2)}
              className="hover:bg-grey-100 uppercase px-4 py-2 text-sm font-bold tracking-wider bg-transparent border-2 rounded-sm mx-1"
            >
              {props.no}
            </button>
          )}
        </div>
      ) : answer === 1 ? (
        <p className="my-10 text-base opacity-60 mr-2">{props.thanksText}</p>
      ) : (
        <div className="my-10 relative">
          <p className="text-base">{props.sorryText}</p>

          <textarea
            className="my-4 p-2 rounded-sm w-full border border-black border-opacity-40"
            type="text"
            placeholder={props.improveText}
            value={comment}
            maxLength={maxLength}
            onChange={(e) => setComment(e.target.value)}
          />
          <span className="relative block bottom-5">
            {charactersRemaining !== 1
              ? props.charactersRemaining.replace('{count}', charactersRemaining)
              : props.charactersRemainingSingular.replace('{count}', charactersRemaining)}
          </span>
          <PrimaryButton className="cursor-pointer" onClick={() => submitFeedBack(false, comment)}>
            {props.submit}
          </PrimaryButton>
        </div>
      )}
    </div>
  )
}
export default YesNoBlock
